import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Modal } from "react-responsive-modal";
import { useCreatePayrollPolicy } from "../../queries/payrollQuries";
import { fullNameRegex } from "../../utils/regex/regex";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddSalaryTemplate = ({ openModal, onCloseModal }) => {
  const { register, handleSubmit, reset, formState } = useForm({
    mode: "onBlur",
  });

  const { mutate: createPayrollPolicy } = useCreatePayrollPolicy();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    reset(); 
    onCloseModal();
  };

  const onSubmit = (data) => {
    setLoading(true);

    createPayrollPolicy(data, {
      onSuccess: (response) => {
        reset();
        onCloseModal();
        toast.success(
          response.message || "Payroll policy created successfully!"
        );
        setLoading(false);
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while creating the payroll policy.";
        toast.error(errorMessage);
        setLoading(false);
      },
    });
  };

  const { errors } = formState;

  return (
    <Modal open={openModal} onClose={handleClose} center>
      <div className="p-5 w-[520px]">
        <h2 className="text-lg leading-6 text-[#1F2937] font-semibold mb-5">
          Add Template
        </h2>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="w-[456px]">
            <label className="text-sm font-medium text-black">
              Name <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              className="h-[38px] border rounded px-2"
              {...register("policy_name", {
                required: "Policy name is required",
                pattern: {
                  value: fullNameRegex,
                  message:
                    "template name must not have spaces or special characters",
                },
              })}
            />
            {errors?.policy_name && (
              <span className="text-red-500 text-xs">
                {errors.policy_name.message}
              </span>
            )}
          </div>
          <div className="w-[456px]">
            <label className="text-sm font-medium text-black">
              Description <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              className="h-[38px] border rounded px-2"
              {...register("policy_description", {
                required: "Policy description is required",
                pattern: {
                  value: fullNameRegex,
                  message:
                    "template description must not have spaces or special characters",
                },
              })}
            />
            {errors?.policy_description && (
              <span className="text-red-500 text-xs">
                {errors.policy_description.message}
              </span>
            )}
          </div>
          <div className="flex justify-end gap-3 mr-5">
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className={`btn btn--border text-sm font-medium ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`btn bg-blue-600 text-white px-4 py-2 rounded ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddSalaryTemplate;
